// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TrackerConfigType } from "./Shared.TrackerConfigType.gen";

export interface ITrackerConfig {
	id: string | undefined;

	dateCreated: string | undefined;

	name: string | undefined;

	description: string | undefined;

	trackerConfig: string | undefined;

	type: TrackerConfigType;

	isDeleted: boolean;

	$type?: string | undefined;
}
export class TrackerConfig {
	constructor(data?: ITrackerConfig) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	name: string | undefined;

	description: string | undefined;

	trackerConfig: string | undefined;

	type: TrackerConfigType = 0;

	isDeleted: boolean = false;

	static $type: string = "CoreApi.Models.TrackerConfig, ";
	$type?: string | undefined = TrackerConfig.$type;
}

